import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { CERTIFICATION, FOOTPRINT, FOOTPRINT_TOTALS } from '../data/site';
export function Footprint() {
  return <section className="border-b border-ink-100" data-id="element-28" data-mp="381sa04ja2og8">
      <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-24" data-id="element-29" data-mp="37z603y8wzwuu">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-30" data-mp="3d0d8nzivt02k">
          <div data-id="element-31" data-mp="4lbpp11pjwef">
            <SectionLabel data-id="element-32" data-mp="4kti589lhvr7">Where PropFlow runs today</SectionLabel>
            <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-4xl" data-id="element-33" data-mp="9jmxl68fzwu0">
              {FOOTPRINT_TOTALS.units} units under management and counting
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-ink-600" data-id="element-34" data-mp="3vps85pix5h4u">
              Real tenants, real rent, and real maintenance tickets — running on
              PropFlow every day in Rwanda and Uganda.
            </p>

            <div className="mt-10 flex items-start gap-4 border-l-2 border-bronze-500 pl-5" data-id="element-35" data-mp="2kcpsqxsk2xm9">
              <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-bronze-600" aria-hidden="true" data-id="element-36" data-mp="kygh7qb22izf" />
              <div data-id="element-37" data-mp="tyd4bnhsr9sd">
                <p className="text-sm font-semibold text-ink-900" data-id="element-38" data-mp="tyv42u3o4651">
                  {CERTIFICATION.label}
                </p>
                <p className="mt-1.5 max-w-md text-sm leading-relaxed text-ink-600" data-id="element-39" data-mp="oxyubzwmxprp">
                  {CERTIFICATION.text}
                </p>
              </div>
            </div>
          </div>

          <div data-id="element-40" data-mp="yx6f385p8mou">
            <table className="w-full border-collapse text-left" data-id="element-41" data-mp="yvlmho2y3dtm">
              <caption className="sr-only" data-id="element-42" data-mp="1co1jo8960hmm">PropFlow footprint by market</caption>
              <thead data-id="element-43" data-mp="18n96j3x69sl2">
                <tr className="border-b border-ink-300" data-id="element-44" data-mp="18osm0sb07zls">
                  <th scope="col" className="pb-4 pr-6 text-sm font-medium text-ink-500" data-id="element-45" data-mp="1mn0qrmea857i">
                    Market
                  </th>
                  <th scope="col" className="pb-4 text-right text-sm font-medium text-ink-500" data-id="element-46" data-mp="1hpiepn4yx9va">
                    Units
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-47" data-mp="jdek1p9qnf3x">
                {FOOTPRINT.map(row => <tr key={row.market} className="border-b border-ink-100" data-id="element-48" data-mp="obpt3xs7lll3">
                    <th scope="row" className="py-6 pr-6 align-baseline" data-id="element-49" data-mp="o9d4j1ry4cz2">
                      <span className="block text-2xl font-semibold tracking-tight text-ink-900" data-id="element-50" data-mp="t3qzj32p4i37">
                        {row.market}
                      </span>
                      <span className="mt-1 block text-sm font-normal text-ink-500" data-id="element-51" data-mp="12zuamyfizr2a">
                        {row.country}
                      </span>
                    </th>
                    <td className="py-6 text-right align-baseline text-3xl font-semibold tracking-tight text-bronze-600" data-id="element-52" data-mp="1c11x8j8oj3gj">
                      {row.units}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-53" data-mp="3dtghhoyp4k04">
                <tr data-id="element-54" data-mp="3dsnhr7y5murh">
                  <th scope="row" className="pt-5 pr-6 text-sm font-medium text-ink-700" data-id="element-55" data-mp="3du896op69xl4">
                    Total
                  </th>
                  <td className="pt-5 text-right text-base font-semibold text-bronze-600" data-id="element-56" data-mp="31hw34egle9bn">
                    {FOOTPRINT_TOTALS.units}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </section>;
}